import React from 'react'
import MessageTableBody from './MessageTableBody'
import TableRow from './TableRow'
import { PDFExport } from '@progress/kendo-react-pdf';

const MessageTemplateTable = React.forwardRef(({ data }, ref) => {
    return (
        <>
            <div className="flex flex-col">
                <div className="overflow-x-auto sm:mx-3 md:mx-4 lg:mx-3">
                    <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                        <div className="overflow-hidden">

                            <PDFExport paperSize="A4" scale={0.6} avoidLinks={true} landscape={true} ref={ref}>
                                <table className="min-w-full border text-center" id='table-to-xls'>
                                    <thead className="tableborder font-semibold">
                                        <tr className="tableborder">
                                            <TableRow
                                                tableTitle="Sr.No"
                                            />
                                            <TableRow
                                                tableTitle="Template ID"
                                            />
                                            <TableRow
                                                tableTitle="Message Type"
                                            />
                                            <TableRow
                                                tableTitle="Message"
                                            />
                                            <TableRow
                                                tableTitle="Action"
                                            />
                                        </tr>
                                    </thead>
                                    <tbody className='text-left'>
                                        {data.map((item, index) => <MessageTableBody key={index} item={item} />)}
                                    </tbody>
                                </table>
                            </PDFExport>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
});

export default MessageTemplateTable